import React from 'react'

const Footer = () => {
 return (
 <footer style={{
 background: 'linear-gradient(135deg, var(--text-dark), #374151)',
 color: 'white',
 padding: '60px 0 20px'
 }}>
 <div className="container">
 <div style={{
 display: 'grid',
 gridTemplateColumns: 'repeat(auto-fit, minmax(250px,1fr))',
 gap: '40px',
 marginBottom: '40px'
 }}>
 <div>
 <div style={{
 display: 'flex',
 alignItems: 'center',
 gap: '8px',
 marginBottom: '20px'
 }}>
 <div style={{
 width: '32px',
 height: '32px',
 background: 'linear-gradient(135deg, #ff6b8b, #8b5cf6)',
 borderRadius: '8px',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 color: 'white',
 fontWeight: 'bold',
 fontSize: '14px'
 }}>
甜 </div>
 <span style={{
 fontSize: '1.5rem',
 fontWeight: '700',
 color: 'white'
 }}>
甜蜜时光 </span>
 </div>
 <p style={{
 color: '#d1d5db',
 lineHeight: '1.6',
 marginBottom: '20px'
 }}>
专业烘焙，用心制作。我们致力于将甜蜜与幸福传递给每一位顾客。
 </p>
 </div>
 <div>
 <h4 style={{
 fontSize: '1.125rem',
 fontWeight: '600',
 marginBottom: '20px',
 color: 'white'
 }}>
快速链接 </h4>
 <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
 <a href="#products" style={{ color: '#d1d5db', textDecoration: 'none' }}>产品展示</a>
 <a href="#about" style={{ color: '#d1d5db', textDecoration: 'none' }}>关于我们</a>
 <a href="#contact" style={{ color: '#d1d5db', textDecoration: 'none' }}>联系我们</a>
 </div>
 </div>
 <div>
 <h4 style={{
 fontSize: '1.125rem',
 fontWeight: '600',
 marginBottom: '20px',
 color: 'white'
 }}>
联系信息 </h4>
 <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', color: '#d1d5db' }}>
 <div>上海市黄浦区南京东路123号</div>
 <div>400-123-4567</div>
 <div>hello@sweettime.com</div>
 </div>
 </div>
 <div>
 <h4 style={{
 fontSize: '1.125rem',
 fontWeight: '600',
 marginBottom: '20px',
 color: 'white'
 }}>
关注我们 </h4>
 <div style={{ display: 'flex', gap: '16px' }}>
 <div style={{
 width: '40px',
 height: '40px',
 background: 'rgba(255,255,255,0.1)',
 borderRadius: '8px',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 cursor: 'pointer',
 transition: 'background 0.3s ease'
 }}>
微 </div>
 <div style={{
 width: '40px',
 height: '40px',
 background: 'rgba(255,255,255,0.1)',
 borderRadius: '8px',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 cursor: 'pointer',
 transition: 'background 0.3s ease'
 }}>
抖 </div>
 <div style={{
 width: '40px',
 height: '40px',
 background: 'rgba(255,255,255,0.1)',
 borderRadius: '8px',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 cursor: 'pointer',
 transition: 'background 0.3s ease'
 }}>
小 </div>
 </div>
 </div>
 </div>
 <div style={{
 borderTop: '1px solid rgba(255,255,255,0.1)',
 paddingTop: '20px',
 textAlign: 'center',
 color: '#9ca3af'
 }}>
 <p>©2024甜蜜时光蛋糕店.保留所有权利.</p>
 </div>
 </div>
 </footer>
 )
}

export default Footer